export default "__VITE_ASSET__874c61dd__"